import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { PROJECTS } from './actions';
import { ProjectDTO, IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';
import { C4ListResponse } from '@domain/interface/c4-list-response';

export const reducers = createReducer(
	initialState,
	on(PROJECTS.PROJECTS_LIST.GET, (state) => ({ ...state, loading: true })),
	on(PROJECTS.PROJECTS_LIST.SUCCESS, (state, action: C4ListResponse<ProjectDTO>) => ({
		...state,
		loading: false,
		projects: action.data,
		total: action.totalElements,
	})),
	on(PROJECTS.PROJECTS_LIST.FAILURE, (state, action) => ({
		...state,
		loading: false,
		error: action.payload.message,
	})),

	on(PROJECTS.USERS_LIST.SET, (state, action) => ({
		...state,
		usersList: action.usersList,
	})),

	on(PROJECTS.SORT.SET, (state, action) => ({
		...state,
		sort: action.sort,
	})),
	on(PROJECTS.FILTERS.SET, (state, action) => ({
		...state,
		filters: action.filters,
	})),

	on(PROJECTS.TABS.SET, (state, action) => ({
		...state,
		allTabs: action.allTabs,
	})),

	// update state fields
	on(PROJECTS.ACTIVE_TAB.SET, (state, action) => ({
		...state,
		activeTab: action.activeTab,
	})),
	on(PROJECTS.USERS_SORT_AND_FILTERS.SET, (state, action) => ({
		...state,
		userSortAndFilters: action.userSortAndFilters,
	})),

	// update project fields
	on(PROJECTS.EDIT_PROJECT.UPDATE_DUE_DATE, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.dueDate = action.dueDate;
			}
			return projectDTO;
		}),
	})),
	on(PROJECTS.EDIT_PROJECT.UPDATE_CUSTOMER, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.customerDTO = action.customerDTO;
			}
			return projectDTO;
		}),
	})),
	on(PROJECTS.EDIT_PROJECT.UPDATE_ASSIGNEE, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.assigneeId = action.assigneeId;
			}
			return projectDTO;
		}),
	})),
	on(PROJECTS.EDIT_PROJECT.UPDATE_OUT_OF_NETWORK, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			let projectDTO = Object.assign({}, project);
			if (action.projectIds.indexOf(project.id) !== -1) {
				projectDTO.sendToOutOfNetworkCarriers = action.sendToOutOfNetworkCarriers;
			}
			return projectDTO;
		}),
	})),

	on(PROJECTS.HISTORICAL_LOADS_COUNT.SUCCESS, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			const matchedProjectedStats = action?.data?.find((stat) => stat.projectId === project.id);
			if (matchedProjectedStats) {
				let projectDTO = Object.assign({}, project);
				if (IS_NULL_OR_UNDEFINED(project.loadsCount)) {
					projectDTO.loadsCount = matchedProjectedStats.loadCount;
				} else {
					projectDTO.loadsCount += matchedProjectedStats.loadCount;
				}
				return projectDTO;
			}
			return project;
		}),
	})),

	on(PROJECTS.ACTIVE_LOADS_COUNT.SUCCESS, (state, action) => ({
		...state,
		projects: state.projects.map((project) => {
			const matchedProjectedStats = action?.data?.find((stat) => stat.projectId === project.id);
			if (matchedProjectedStats) {
				let projectDTO = Object.assign({}, project);
				if (IS_NULL_OR_UNDEFINED(project.loadsCount)) {
					projectDTO.loadsCount = matchedProjectedStats.loadsCount;
				} else {
					projectDTO.loadsCount += matchedProjectedStats.loadsCount;
				}
				return projectDTO;
			}
			return project;
		}),
	}))
);
